import React from 'react';
import styles from './Tooltip.module.css';
const Tooltip = (props)=> {
    return <div className={styles.Tooltip}><span>{props.children}</span></div>
}

export default Tooltip;